import React from 'react';
import { NavLink, useLocation, useRouteMatch } from 'react-router-dom';
import { useHeaderTabsCssClasses } from '../hooks';
import './HeaderTabItem.scss';
export const HeaderTabItem = ({ path, displayValue, }) => {
    const isActive = useRouteMatch(path);
    const { search } = useLocation();
    const { headerTabItem } = useHeaderTabsCssClasses({ isActive });
    return (React.createElement(NavLink, { key: path, to: { pathname: path, search }, className: headerTabItem }, displayValue));
};
//# sourceMappingURL=HeaderTabItem.js.map